import FileUtility from './FileUtility'

export default {
  File: FileUtility
}
